import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ToastModule } from '@libs/src/toast/toast.module';

import { ConversationsEffectsService } from './conversations-effects.service';
import { ToastService } from '@libs/src/toast/toast.service';

import { conversationsReducer } from './conversations.reducer';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    EffectsModule.forFeature([ConversationsEffectsService]),
    StoreModule.forFeature('conversations', conversationsReducer),
  ],
  providers: [ToastService, ConversationsEffectsService, ToastModule],
})
export class ConversationsStoreModule {}
